import { Injectable, Injector, Type } from '@angular/core';


/**------------------------------------------------------
 * App Injector
 * ------------
 * > Getting instance of service without constructor injection
 * > Example: const authSecurityInstance = NgAppInjectorService.getStaticAppInjectorInstance(AuthSecurityService)
 * ------------
 * > Note: Allows for retrieving singletons using "AppInjector.getStaticAppInjectorInstance(MyService)" (whereas
 * > "ReflectiveInjector.resolveAndCreate(MyService)" would create a new instance of the service).
 */
@Injectable({
	providedIn: 'root'
})
export class NgAppInjectorService {

	// ✅ Static and instance-based injector
	private static injector?: Injector;
	private injector?: Injector;

	constructor(injector: Injector) {
		this.setAppInjectorInstance(injector); // ✅ Automatically set injector on app start
	}

	/**
	 * ✅ Sets the Injector instance (Both static & instance)
	 * Only sets it if it's not already initialized.
	 */
	setAppInjectorInstance(injectorInstance: Injector): void {
		if (!this.injector) {
			this.injector = injectorInstance; // ✅ Instance-based access
		}
		if (!NgAppInjectorService.injector) {
			NgAppInjectorService.injector = injectorInstance; // ✅ Static access
		}
	}

	/**
	 * ✅ Retrieve an instance via DI (Instance-based)
	 */
	getAppInjectorInstance<T>(token: Type<T>): T {
		if (!this.injector) throw new Error(`NgAppInjectorService => ERROR: Instance injector is not set.`);
		return this.injector.get(token);
	}

	/**
	 * ✅ Retrieve an instance globally (Static)
	 */
	static getStaticAppInjectorInstance<T>(token: Type<T>): T {
		if (!NgAppInjectorService.injector) throw new Error(`NgAppInjectorService => ERROR: Static injector is not set.`);
		return NgAppInjectorService.injector.get(token);
	}
}
